export default "__VITE_ASSET__BhG_BTOO__"